export default __webpack_public_path__ + "static/media/lovrican-theme_white-small.24680098.svg";